import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FileService } from '../services/file.service';
import { SafeHtmlPipe } from './pipes/SafeHtmlPipe';
import { AuthImagePipe } from './pipes/AuthImagePipe';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  exports: [
      AuthImagePipe,
      SafeHtmlPipe,
  ],
  declarations: [
      AuthImagePipe,
      SafeHtmlPipe,
  ],
  providers: [
    FileService,
  ]
})
export class ComponentsModule {}